/*
 * @Descripttion:
 * @version:
 * @Author: dengyao
 * @Date: 2023-07-02 10:01:19
 * @LastEditors: hongye
 * @LastEditTime: 2026-03-30 17:38:28
 */
import { defineStore } from 'pinia'
import { expressService } from '@/service/api'
import { lang } from '@/utils'
interface ExpressListVo {
  label: string
  value: string
}
export const useExpressList = defineStore('express', {
  state: () => ({
    /**快递公司 */
    expressList: [] as ExpressListVo[],
    /**默认快递公司 */
    expressId: ''
  }),
  getters: {
    getExpressData: (state) => {
      return state.expressList.map((item) => ({
        ...item,
        label: item.value === '' ? lang('全部') : item.label
      }))
    }
  },
  actions: {
    /**
     * 获取所有快递公司
     * @param
     * @returns promise
     */
    getExpressList() {
      return new Promise((resolve, reject) => {
        expressService
          .getExpressList()
          .then((res) => {
            if (res.code === 1) {
              this.expressList = [
                {
                  label: lang('全部'),
                  value: ''
                }
              ]
              res.data.forEach((_: { value: any; key: any }) => {
                this.expressList.push({
                  label: _.value,
                  value: _.key
                })
              })
              const expressObj = res.data.find((_: { value: string }) => {
                return (_.value === 'JT_EXPRESS')
              })
              this.expressId = expressObj?.key || ''
            }
            resolve(res)
          })
          .catch((err) => reject(err))
      })
    },
    initExpressId() {
      return new Promise((resolve, reject) => {
        if (this.expressId) {
          resolve(this.expressId)
        } else {
          this.getExpressList().then(() => resolve(this.expressId)).catch((err) => reject(err))
        }
      })
    }
  },
  persist: {
    storage: localStorage
  }
})
